import { vn } from 'vend-number'
import { hasCashDiscountingServiceFee } from '../../../../functions/payments'
import { getOutstandingBalance } from '../../../../functions/sale'
import { useRegisterManager, useSaleManager } from '../../../../ng-compat/hooks'
import { useAppSelector } from '../../../../state/hooks'
import { selectCurrentSaleAsSale } from '../../../../state/slices/currentSale/currentSaleSlice'

export const usePaymentAmountForCashDiscounting = () => {
  const sale = useAppSelector(selectCurrentSaleAsSale)
  const registerManager = useRegisterManager()
  const saleManager = useSaleManager()

  const getPaymentAmountForCashDiscounting = (amountTendered: string) => {
    const tenderedAmountMatchesBalance = vn(amountTendered).eq(
      getOutstandingBalance(sale)
    )
    const hasCashDiscounting = registerManager.hasCashDiscounting()

    // Only adjust the amount tendered when Cash Discounting is enabled, the sale has a positive service fee and the
    // amount tendered matches the outstanding balance
    if (
      hasCashDiscountingServiceFee(hasCashDiscounting, sale) &&
      tenderedAmountMatchesBalance
    ) {
      return saleManager.getCashDiscountedOutstandingBalance()
    }

    return amountTendered
  }

  return { getPaymentAmountForCashDiscounting }
}
